<div role="navigation" aria-label="Main Product Details" name="resultsDiv" id="resultsDiv"
	class="product-details-main-container">

	<!-- BEGINNING OF GRID LAYOUT -->
	<div class="product-details-container clearfix" *ngIf="layoutType === 'grid'"
		[class.grid-bottom-margin]="setBottomMargin">
		<div aria-haspopup="true" tabindex="0" class="droplink product-details-grid-tile grid-tile-spacing"
			*ngFor="let productDetail of productDetails; let i = index">

			<div *ngIf="productDetail.isFeaturedProduct" class="product-details-featured-product image-cont">{{
				'featured' | translate }}</div>
			<div *ngIf="!productDetail.isFeaturedProduct" class="product-details-featured-product image-cont"
				style="visibility: hidden">{{ 'featured' | translate }}</div>

			<div style="position: relative;">
				<div class="product-details-image-container">
					<img width="100%" height="100%" title="{{productDetail.displayName}} "
						src="{{productDetail.imageURL}}" alt="{{productDetail.displayName}}"
						(load)="createThumbnail($event.target)" (error)="showImgError($event.target)" />
				</div>
				<a class="product-title" *ngIf="productDetail.isPDP;else title_content"
					href='{{getPDPLink(productDetail)}}' target="_blank" rel="noopener">
					<h2 class="product-name h--smallest" [innerHTML]="productDetail.productTitle"></h2>
				</a>
				<ng-template #title_content>
					<h2 class="product-name h--smallest" [innerHTML]="productDetail.productTitle"></h2>
				</ng-template>
				<div class="specs-container"
					[ngClass]="{'specs-container-grid-laptop': productDetail.category === 'LAPTOP'}">
					<ul>
						<li *ngFor="let specs of productDetail.productInfo">
							<div class="specs p-medium p-medium">
								<div style="display: inline-block;">{{specs.name | translate}}:&nbsp;{{valueTrimmer(specs.value)}}
									{{(((productDetail.category==='LAPTOP' || productDetail.category==='STUDIO-LAPTOP')
									&& specs.name =='gpu')?'gpu_spec_sufix':'') | translate}}</div>
							</div>
						</li>
					</ul>
				</div>
				<div #drSpinnerCont *ngIf="productDetail.digitialRiverID" class="dr-spinner-bg-grid 40">
					<div #drId *ngIf="productDetail.digitialRiverID" class="product-row__item js-product-item 45"
						data-analytics="btn-dr-id"
						[attr.data-digital-river-id]="changeDRId(productDetail.digitialRiverID)">
						<div #priceDiv class="price js-product-price clearfix h--smallest 42"></div>
						<div class="price  outside-page 43"> <span
								[innerHtml]="extractDRPriceIntegerDot(priceDiv, drSpinnerCont)"></span><span
								class="decimal" [innerHtml]="extractDRPriceDecimal(priceDiv)"></span> </div>
						<div class="cta-preorder mobile-top"
							[class.outside-page]="screenWidth === 'LG' || screenWidth === 'XL'"
							(click)="transmitToCart()">
							<!-- Logic for NOTIFY ME -->
							<!-- DR NOTIFY ME -->
							<a *ngIf="productDetail.prdStatus === 'dr_notify_me'"
								class="featured-buy-link link-btn brand-green  cta-button show-dr-notify-me cta-link-large 44"
								href="javascript:void(0);">
								{{ 'out_of_stock' | translate }}
							</a>
							<!-- END OF DR NOTIFY ME -->
							<!-- NV NOTIFY ME --><a *ngIf="productDetail.prdStatus === 'nv_notify_me'"
								class="featured-buy-link link-btn brand-green  cta-button show-nv-notify-me cta-link-large"
								data-nvnotify-form-path="/content/forms/af/nvidia-forms/products-notify-me/consumer-notify-me"
								href="javascript:void(0);">
								{{ 'out_of_stock' | translate }}
							</a>
							<!-- END OF NV NOTIFY ME --><a *ngIf="productDetail.prdStatus === 'buy_now'"
								class="featured-buy-link link-btn brand-green  cta-button cta-link-large"
								href="javascript:void(0);">
								{{ 'add_to_cart' | translate }}
							</a>
							<!-- OUT OF STOCK --><a *ngIf="productDetail.prdStatus === 'out_of_stock'"
								class="featured-buy-link link-btn brand-green  cta-button show-out-of-stock cta-link-large"
								href="javascript:void(0);">
								{{ 'out_of_stock' | translate }}
							</a>
							<!-- END OF OUT OF STOCK -->
							<!-- <div class="product__message limit-per-customer">{{'limit_5' | translate}}</div> -->
							<div *ngIf="productDetail.retailers?.length > 0" class="buy fpc-66"
								[class.fe-pids]="productDetail.manufacturer==='NVIDIA'">
								<div [attr.class]="getEANCode(productDetail.productUPCOriginal)"
									[attr.id]="productDetail.productID" style="display:none">{{productDetail.retailers |
									json}}</div>
								<div>
									<button class="extra_style buy-link cta-link-larges 68 buy-frm-partner"
										[attr.data-pid-code]="productDetail.productID"
										[attr.data-mpn-code]="getEANCode(productDetail.productUPCOriginal)"
										data-color="#76b900" data-secondary-color="#fff"
										(click)="productName(productDetail);">
										{{'buy_from_partners' | translate}}
									</button>
								</div>
							</div>

						</div>

						<div class="ship-date 77"></div>
					</div>
					<div class="compare-remove-container pdc-68"
						style="padding-bottom: 30px; display: flex; justify-content: space-between;"
						[class.outside-page]="screenWidth === 'LG' || screenWidth === 'XL'">
						<button class="cta-link-regular 69" [attr.id]="('compare_'+productDetail.productUPC)"
							style="flex:inherit" [class.compare]="productDetail.addRemoveCompare === 'Compare'"
							[class.remove]="productDetail.addRemoveCompare === 'Remove'"
							(click)="compareProduct(productDetail)">{{productDetail.addRemoveCompare | lowercase |
							translate}}</button>

						<popover role="button" tabindex="0" *ngIf="productDetail.isOffer" [screenwidth]="screenWidth"
							[type]="'Game Bundle'" [offerLabel]="'game_bundle' | translate"
							[bundle]="productDetail.offerText"></popover>
						<popover role="button" tabindex="0" *ngIf="productDetail.shipInfo" [screenwidth]="screenWidth"
							[type]="'Availability'" [availability]="productDetail.shipInfo"></popover>
					</div>
				</div>
				<div *ngIf="productDetail.digitialRiverID" class="75">
					<dr-loading-indicator [show]="drLoading"></dr-loading-indicator>
				</div>
				<div *ngIf="!productDetail.digitialRiverID" class="product_detail_78">
					<div class="product-details-price-stock">
						<div class="price clearfix h--smallest 80" *ngIf="locale === 'ru-ru' || locale === 'pl-pl'">
							<span [innerHtml]="getFormatedPrice(productDetail.productPrice,locale)"></span></div>
						<div class="price clearfix h--smallest 81" *ngIf="locale !== 'ru-ru' && locale !=='pl-pl'">
							<span [innerHtml]="getPriceIntegerDot(productDetail.productPrice)"></span>
							<span class="decimal" [innerHtml]="getPriceDecimal(productDetail.productPrice)"></span>
						</div>
					</div>
					<div *ngIf="screenWidth === 'SM' || screenWidth === 'MD'">
						<div class="clearfix pdc-86" [class.fe-pids]="productDetail.manufacturer==='NVIDIA'"
							style="padding-bottom: 30px;">
							<div *ngIf="productDetail.prdStatus !== 'gf_notify_me'">
								<div *ngIf="productDetail.prdStatus !== 'upcoming'">
									<div *ngIf="productDetail.prdStatus !== 'check_availability' && productDetail.prdStatus !== 'out_of_stock'">
										<a href="javascript:void(0)"> 
											<span class="extra_style buy-link cta-link-large" (click)="productName(productDetail); detectBuyClick();"
										 [attr.data-pid-code]="productDetail.productID" data-color="#76b900" data-secondary-color="#fff"
										  [attr.data-mpn-code]="getEANCode(productDetail.productUPCOriginal)">
										  {{productDetail.prdStatus| translate}}</span> 
										</a>
									</div>
								</div>
							</div>
							<button *ngIf="productDetail.prdStatus === 'check_availability'"
								class="extra_style buy-link 98" styles="" [attr.data-pid-code]="productDetail.productID"
								[attr.data-mpn-code]="getEANCode(productDetail.productUPCOriginal)" data-color="#76b900"
								data-secondary-color="#fff"
								(click)="productName(productDetail); detectBuyClick();">{{'check_availability' |
								translate}}</button>
								<div *ngIf="productDetail.prdStatus === 'gf_notify_me'"
								class="buy cta-preorder mobile-top lb_iframe"
								[attr.data-href]="getFormPath(locale, productDetail.productTitle)" href="#"
								target="overlay"
								onclick="NVIDIAGDC.button.click(this, $(this).data('href'),true, function() { ;return NVIDIAGDC.button.callbacks(this); }); return false;">
								<a class="featured-buy-link cta-link-large link-btn brand-green cta-button show--me notify-me-btn"
									data-nvnotify-form-path="/content/forms/af/nvidia-forms/products-notify-me/consumer-notify-me"
									href="javascript:void(0);">{{'notify_me' | translate}}</a>
							</div> <a
								*ngIf="productDetail.prdStatus === 'upcoming' || productDetail.prdStatus === 'out_of_stock'"
								class="100 featured-buy-link link-btn brand-green  cta-button stock-grey-out cta-link-large"
								href="javascript:void(0);">
								{{ productDetail.prdStatus | translate }}
							</a>
						</div>
						<div class="compare-remove-container pdc-104"
							style="padding-bottom: 30px; display: flex; justify-content: space-between;">
							<button class="cta-link-regular 105" [attr.id]="('compare_'+productDetail.productUPC)"
								[class.compare]="productDetail.addRemoveCompare === 'Compare'"
								[class.remove]="productDetail.addRemoveCompare === 'Remove'"
								(click)="compareProduct(productDetail)">{{productDetail.addRemoveCompare | lowercase |
								translate}}</button>
							<popover role="button" tabindex="0" *ngIf="productDetail.isOffer"
								[screenwidth]="screenWidth" [type]="'Game Bundle'"
								[offerLabel]="'game_bundle' | translate" [bundle]="productDetail.offerText"></popover>
						</div>
					</div>
				</div>
			</div>
			<!-- product hover effect -->
			<div aria-label="Product hover effect" *ngIf="!productDetail.digitialRiverID"
				class="product-details-grid-overview 120">
				<div *ngIf="productDetail.isFeaturedProduct" class="product-details-featured-product image-cont">{{
					'featured' | translate }}</div>
				<div *ngIf="!productDetail.isFeaturedProduct" class="product-details-featured-product image-cont"
					style="visibility: hidden">{{ 'featured' | translate }}</div>
				<div class="product-details-image-container">
					<a href='{{getPDPLink(productDetail)}}' target="_blank" rel="noopener noreferrer"
						*ngIf="productDetail.isPDP;else img_content">
						<img title="{{productDetail.displayName}} " src="{{productDetail.imageURL}}"
							alt="{{productDetail.displayName}}" (load)="createThumbnail($event.target)"
							(error)="showImgError($event.target)" width="100%" height="100%" />
					</a>
					<ng-template #img_content>
						<img title="{{productDetail.displayName}} " src="{{productDetail.imageURL}}"
							alt="{{productDetail.displayName}}" (load)="createThumbnail($event.target)"
							(error)="showImgError($event.target)" width="100%" height="100%" />
					</ng-template>
				</div>
				<a class="product-title" *ngIf="productDetail.isPDP;else title_content"
					href='{{getPDPLink(productDetail)}}' target="_blank" rel="noopener">
					<h2 class="product-name h--smallest" [innerHTML]="productDetail.productTitle"></h2>
				</a>
				<ng-template #title_content>
					<h2 class="product-name h--smallest" [innerHTML]="productDetail.productTitle"></h2>
				</ng-template>
				<div class="specs-container"
					[ngClass]="{'specs-container-grid-laptop': productDetail.category === 'LAPTOP'}">
					<ul>
						<li *ngFor="let specs of productDetail.productInfo">
							<div class="specs p-medium p-medium">
								<div style="display: inline-block;">{{specs.name | translate}}:&nbsp;{{valueTrimmer(specs.value)}}
									{{((((productDetail.category==='LAPTOP' || productDetail.category==='STUDIO-LAPTOP')
									|| productDetail.category==='STUDIO-LAPTOP') && specs.name
									=='gpu')?'gpu_spec_sufix':'') | translate}}</div>
							</div>
						</li>
					</ul>
					<popover role="button" tabindex="0" *ngIf="productDetail.shipInfo" [screenwidth]="screenWidth"
						[type]="'Availability'" [availability]="productDetail.shipInfo"></popover>
				</div>
				<div class="product-details-price-stock">
					<div class="price clearfix h--smallest 139" *ngIf="locale === 'ru-ru' || locale==='pl-pl'" 
						[innerHtml]="getFormatedPrice(productDetail.productPrice,locale)"></div>
						
					<div class="price clearfix h--smallest 140" *ngIf="locale !== 'ru-ru' && locale !=='pl-pl'">
						<span [innerHtml]="getPriceIntegerDot(productDetail.productPrice)"></span>
						<span class="decimal" [innerHtml]="getPriceDecimal(productDetail.productPrice)"></span>
					</div>
				</div>

				<div class="clearfix pdc-139" [class.fe-pids]="productDetail.manufacturer==='NVIDIA'"
					style="padding-bottom: 15px;">
					<div [attr.id]="productDetail.productID" [attr.class]="getEANCode(productDetail.productUPCOriginal)"
						style="display:none; visibility:hidden">{{productDetail.retailers | json}}</div>
					<!-- <span *ngIf="productDetail.prdStatus !== 'gf_notify_me'" class="extra_style buy-link cta-link-large 149" style="visibility:hidden" [attr.data-pid-code]="productDetail.productID" [attr.data-mpn-code]="getEANCode(productDetail.productUPCOriginal)" data-color="#76b900" data-secondary-color="#fff" (click)="productName(productDetail)" >{{productDetail.prdStatus| translate }}</span>-->
					<div *ngIf="productDetail.prdStatus !== 'gf_notify_me'">
						<div *ngIf="productDetail.prdStatus !== 'upcoming'">
							<div
								*ngIf="productDetail.prdStatus !== 'check_availability' && productDetail.prdStatus !== 'out_of_stock'">
								<button class="extra_style buy-link cta-link-large 152 "
									[attr.data-pid-code]="productDetail.productID"
									[attr.data-mpn-code]="getEANCode(productDetail.productUPCOriginal)"
									data-color="#76b900" data-secondary-color="#fff"
									(click)="productName(productDetail); detectBuyClick();">{{productDetail.prdStatus|
									translate }}</button>
								<!-- <input *ngIf="locale !== 'en-us'" type="button" class="buy-link cta-link-large" value="{{productDetail.prdStatus| translate }}" (click)="showOverlay(productDetail)" /> -->
							</div>
						</div>
					</div>
					<button *ngIf="productDetail.prdStatus === 'check_availability'"
						class="extra_style buy-link cta-link-large 158" [attr.data-pid-code]="productDetail.productID"
						[attr.data-mpn-code]="getEANCode(productDetail.productUPCOriginal)" data-color="#76b900"
						data-secondary-color="#fff"
						(click)="productName(productDetail); detectBuyClick();">{{'check_availability' |
						translate}}</button>

					<!-- <input *ngIf="locale !== 'en-us'" type="button" class="buy-link cta-link-large" value="{{productDetail.prdStatus| translate }}" (click)="showOverlay(productDetail)" /> -->
					<div *ngIf="productDetail.prdStatus === 'gf_notify_me'"
						class="buy cta-preorder mobile-top lb_iframe"
						[attr.data-href]="getFormPath(locale, productDetail.productTitle)" href="#" target="overlay"
						onclick="NVIDIAGDC.button.click(this, $(this).data('href'),true, function() { ;return NVIDIAGDC.button.callbacks(this); }); return false;">
						<a class="featured-buy-link link-btn brand-green cta-button show--me notify-me-btn cta-link-large"
							data-nvnotify-form-path="/content/forms/af/nvidia-forms/products-notify-me/consumer-notify-me"
							href="javascript:void(0);">{{'notify_me' | translate}}</a>
					</div>
					<a *ngIf="productDetail.prdStatus === 'upcoming' || productDetail.prdStatus === 'out_of_stock'"
						class="156 featured-buy-link link-btn brand-green  cta-button stock-grey-out cta-link-large"
						href="javascript:void(0);">
						{{ productDetail.prdStatus | translate }}
					</a>

				</div>
				<div style="display: flex; justify-content: space-between; flex-wrap: wrap">
					<div class="compare-remove-container pdc-162" style="padding-bottom: 30px; flex: 50%">
						<button class="cta-link-regular 163" [attr.id]="('compare_'+productDetail.productUPC)"
							[class.compare]="productDetail.addRemoveCompare === 'Compare'"
							[class.remove]="productDetail.addRemoveCompare === 'Remove'"
							(click)="compareProduct(productDetail)">{{productDetail.addRemoveCompare | lowercase |
							translate}}</button>
					</div>
					<popover role="button" tabindex="0" *ngIf="productDetail.isOffer" [screenwidth]="screenWidth"
						[type]="'Game Bundle'" [offerLabel]="'game_bundle' | translate"
						[bundle]="productDetail.offerText"></popover>
				</div>
			</div>

			<div aria-label="Product hover effect"
				*ngIf="productDetail.digitialRiverID && (screenWidth === 'LG' || screenWidth === 'XL')"
				class="product-details-grid-overview" style="display: block;">
				<div *ngIf="productDetail.isFeaturedProduct" class="product-details-featured-product image-cont">{{
					'featured' | translate }}</div>
				<div *ngIf="!productDetail.isFeaturedProduct" class="product-details-featured-product image-cont"
					style="visibility: hidden">{{ 'featured' | translate }}</div>
				<div class="product-details-image-container">
					<a href='{{getPDPLink(productDetail)}}' target="_blank" rel="noopener noreferrer"
						*ngIf="productDetail.isPDP;else img_content">
						<img title="{{productDetail.displayName}} " src="{{productDetail.imageURL}}"
							alt="{{productDetail.displayName}}" (load)="createThumbnail($event.target)"
							(error)="showImgError($event.target)" width="100%" height="100%" />
					</a>
					<ng-template #img_content>
						<img title="{{productDetail.displayName}} " src="{{productDetail.imageURL}}"
							alt="{{productDetail.displayName}}" (load)="createThumbnail($event.target)"
							(error)="showImgError($event.target)" width="100%" height="100%" />
					</ng-template>
				</div>
				<a class="product-title" *ngIf="productDetail.isPDP;else title_content"
					href='{{getPDPLink(productDetail)}}' target="_blank" rel="noopener">
					<h2 class="product-name h--smallest" [innerHTML]="productDetail.productTitle"></h2>
				</a>
				<ng-template #title_content>
					<h2 class="product-name h--smallest" [innerHTML]="productDetail.productTitle"></h2>
				</ng-template>
				<div class="specs-container">
					<ul>
						<li *ngFor="let specs of productDetail.productInfo">
							<div class="specs p-medium p-medium">
								<div style="display: inline-block;">{{specs.name | translate}}:&nbsp;{{valueTrimmer(specs.value)}}
									{{(((productDetail.category==='LAPTOP' || productDetail.category==='STUDIO-LAPTOP')
									&& specs.name =='gpu')?'gpu_spec_sufix':'') | translate}}</div>
							</div>
						</li>
					</ul>
					<!-- <popover *ngIf="productDetail.isOffer" [screenwidth]="screenWidth" [type]="'Game Bundle'" [bundle]="productDetail.offerText"></popover>
					<br />
					<popover *ngIf="productDetail.shipInfo" [screenwidth]="screenWidth" [type]="'Availability'" [availability]="productDetail.shipInfo"></popover>
					-->
				</div>
				<div #drSpinnerCont *ngIf="productDetail.digitialRiverID" class="dr-spinner-bg-grid 201">
					<div #drId class="product-row__item js-product-item 189" data-analytics="btn-dr-id"
						[attr.data-digital-river-id]="changeDRId(productDetail.digitialRiverID)">
						<div #priceDivOverview class="price js-product-price clearfix h--smallest 203"></div>
						<div class="price  outside-page"> <span
								[innerHtml]="extractDRPriceIntegerDot(priceDivOverview, drSpinnerCont)"></span><span
								class="decimal" [innerHtml]="extractDRPriceDecimal(priceDivOverview)"></span> </div>
						<div class="cta-preorder mobile-top" (click)="transmitToCart()">
							<!-- Logic for NOTIFY ME -->
							<!-- DR NOTIFY ME -->
							<a *ngIf="productDetail.prdStatus === 'dr_notify_me'"
								class="featured-buy-link link-btn brand-green  cta-button show-dr-notify-me 159 cta-link-large"
								href="javascript:void(0);">
								{{ 'add_to_cart' | translate }}
							</a>
							<!-- END OF DR NOTIFY ME -->
							<!-- NV NOTIFY ME -->
							<a *ngIf="productDetail.prdStatus === 'nv_notify_me'"
								class="featured-buy-link link-btn brand-green  cta-button show-nv-notify-me cta-link-large"
								data-nvnotify-form-path="/content/forms/af/nvidia-forms/products-notify-me/consumer-notify-me"
								href="javascript:void(0);">
								{{ 'add_to_cart' | translate }}
							</a>
							<!-- END OF NV NOTIFY ME -->
							<a *ngIf="productDetail.prdStatus === 'buy_now'"
								class="featured-buy-link link-btn brand-green  cta-button cta-link-large"
								href="javascript:void(0);">
								{{ 'add_to_cart' | translate }}
							</a>
							<!-- OUT OF STOCK -->
							<a *ngIf="productDetail.prdStatus === 'out_of_stock'"
								class="featured-buy-link link-btn brand-green  cta-button show-out-of-stock cta-link-large"
								href="javascript:void(0);">
								{{ 'out_of_stock' | translate }}
							</a>
							<!-- END OF OUT OF STOCK -->
							<!-- <div class="product__message limit-per-customer">{{'limit_5' | translate}}</div> -->
							<div *ngIf="productDetail.retailers?.length > 0" class="buy fpc-226"
								[class.fe-pids]="productDetail.manufacturer==='NVIDIA'">
								<div [attr.class]="getEANCode(productDetail.productUPCOriginal)"
									[attr.id]="productDetail.productID" style="display:none">{{productDetail.retailers |
									json}}</div>
								<div>
									<button class="extra_style buy-link cta-link-larges 230 buy-frm-partner"
										[attr.data-pid-code]="productDetail.productID"
										[attr.data-mpn-code]="getEANCode(productDetail.productUPCOriginal)"
										data-color="#76b900" data-secondary-color="#fff"
										(click)="productName(productDetail);">
										{{'buy_from_partners' | translate}}
									</button>
								</div>
							</div>
						</div>
						<div class="ship-date 226"></div>
					</div>
				</div>
				<div *ngIf="productDetail.digitialRiverID">
					<dr-loading-indicator [show]="drLoading"></dr-loading-indicator>
				</div>
				<div style="display: flex; justify-content: space-between; flex-wrap: wrap">
					<div class="compare-remove-container pdc-220"
						style="padding-top: 30px;padding-bottom: 30px; flex: 50%">
						<button class="cta-link-regular 221" [attr.id]="('compare_'+productDetail.productUPC)"
							[class.compare]="productDetail.addRemoveCompare === 'Compare'"
							[class.remove]="productDetail.addRemoveCompare === 'Remove'"
							(click)="compareProduct(productDetail)">{{productDetail.addRemoveCompare | lowercase |
							translate}}</button>
					</div>
					<popover role="button" tabindex="0" *ngIf="productDetail.isOffer" [screenwidth]="screenWidth"
						[type]="'Game Bundle'" [offerLabel]="'game_bundle' | translate"
						[bundle]="productDetail.offerText"></popover>
					<popover role="button" tabindex="0" *ngIf="productDetail.shipInfo" [screenwidth]="screenWidth"
						[type]="'Availability'" [availability]="productDetail.shipInfo"></popover>
				</div>
			</div>

		</div>
	</div>
	<!-- END OF GRID LAYOUT -->
	<!-- BEGINNING OF LIST VIEW -->
	<div class="product-details-container" *ngIf="layoutType === 'list'">
		<div class="product-details-list-tile" *ngFor="let productDetail of productDetails;">
			<div class="img-col-xl">
				<div *ngIf="productDetail.isFeaturedProduct" class="product-details-featured-product image-cont">{{'featured' | translate }}</div>
				<div class="product-details-image-container-list"> 
					<a href='{{getPDPLink(productDetail)}}' target="_blank" rel="noopener noreferrer"
						*ngIf="productDetail.isPDP;else img_content">
						<img #im title="{{productDetail.displayName}}"
						class="featured-img" src="{{productDetail.imageURL}}" alt="{{productDetail.displayName}}"
						(window:resize)="createThumbnailList(im)" (load)="createThumbnailList(im)"
						(error)="showImgError($event.target)" width="100%" height="100%" /> 
					</a>
					<ng-template #img_content>
						<img #im title="{{productDetail.displayName}}"
						class="featured-img" src="{{productDetail.imageURL}}" alt="{{productDetail.displayName}}"
						(window:resize)="createThumbnailList(im)" (load)="createThumbnailList(im)"
						(error)="showImgError($event.target)" width="100%" height="100%" /> 
					</ng-template>
					
					</div>
			</div>
			<div class="details-col">
				<div *ngIf="productDetail.isFeaturedProduct" class="product-details-featured-product"
					style="visibility: hidden">{{ 'featured' | translate }}</div>
				<a class="product-title" *ngIf="productDetail.isPDP;else title_content"
					href='{{getPDPLink(productDetail)}}' target="_blank" rel="noopener">
					<h2 class="product-name h--smallest" [innerHTML]="productDetail.productTitle"></h2>
				</a>
				<ng-template #title_content>
					<h2 class="product-name h--smallest" [innerHTML]="productDetail.productTitle"></h2>
				</ng-template>
				<div class="specs-container"
					[ngClass]="{'specs-container-list-laptop': productDetail.category === 'LAPTOP'}">
					<ul>
						<li *ngFor="let specs of productDetail.productInfo">
							<div class="specs p-medium p-medium">{{specs.name | translate}}:&nbsp;{{valueTrimmer(specs.value)}}
								{{(((productDetail.category==='LAPTOP' || productDetail.category==='STUDIO-LAPTOP') &&
								specs.name =='gpu')?'gpu_spec_sufix':'') | translate}}</div>
						</li>
					</ul>
					<div style="display: flex; justify-content: space-between;">
						<popover role="button" tabindex="0" *ngIf="productDetail.isOffer" [screenwidth]="screenWidth"
							[type]="'Game Bundle'" [offerLabel]="'game_bundle' | translate"
							[bundle]="productDetail.offerText"></popover>
						<popover role="button" tabindex="0" *ngIf="productDetail.shipInfo" [screenwidth]="screenWidth"
							[type]="'Availability'" [offerLabel]="'availability' | translate"
							[availability]="productDetail.shipInfo"></popover>
					</div>
				</div>
			</div>
			<div #drSpinnerCont class="buy-col-lg 253" [class.dr-spinner-bg]="productDetail.digitialRiverID">
				<div *ngIf="productDetail.isFeaturedProduct" class="product-details-featured-product"
					style="visibility: hidden">{{ 'featured' | translate }}</div>
				<div *ngIf="!productDetail.digitialRiverID">
					<div class="price clearfix h--smallest 256" *ngIf="locale === 'ru-ru' || locale==='pl-pl'" 
						[innerHtml]="getFormatedPrice(productDetail.productPrice,locale)"></div>
					<div class="price clearfix h--smallest 257" *ngIf="locale !== 'ru-ru' && locale !=='pl-pl'"> <span
							[innerHtml]="getPriceIntegerDot(productDetail.productPrice)"></span><span class="decimal"
							[innerHtml]="getPriceDecimal(productDetail.productPrice)"></span> </div>
					<div class="buy pdc-258" [class.fe-pids]="productDetail.manufacturer==='NVIDIA'">
						<div [attr.class]="getEANCode(productDetail.productUPCOriginal)"
							[attr.id]="productDetail.productID" style="display:none; visibility:hidden">
							{{productDetail.retailers | json}}</div>
						<div *ngIf="productDetail.prdStatus !== 'gf_notify_me'">
							<div *ngIf="productDetail.prdStatus !== 'upcoming'">
								<div
									*ngIf="productDetail.prdStatus !== 'check_availability'  && productDetail.prdStatus !== 'out_of_stock'">
									<button class="extra_style buy-link cta-link-large 284"
										[attr.data-pid-code]="productDetail.productID"
										[attr.data-mpn-code]="getEANCode(productDetail.productUPCOriginal)"
										data-color="#76b900" data-secondary-color="#fff"
										(click)="productName(productDetail); detectBuyClick();">{{productDetail.prdStatus|
										translate }}
									</button>
								</div>
							</div>
						</div>
						<button *ngIf="productDetail.prdStatus === 'check_availability'"
							class="extra_style buy-link cta-link-large 269" styles=""
							[attr.data-pid-code]="productDetail.productID"
							[attr.data-mpn-code]="getEANCode(productDetail.productUPCOriginal)" data-color="#76b900"
							data-secondary-color="#fff"
							(click)="productName(productDetail); detectBuyClick();">{{'check_availability' |
							translate}}
						</button>
						<div *ngIf="productDetail.prdStatus === 'gf_notify_me'"
							class="buy cta-preorder mobile-top lb_iframe"
							[attr.data-href]="getFormPath(locale, productDetail.productTitle)" href="#" target="overlay"
							onclick="NVIDIAGDC.button.click(this, $(this).data('href'),true, function() { ;return NVIDIAGDC.button.callbacks(this); }); return false;">
							<a class="featured-buy-link link-btn brand-green cta-button show--me notify-me-btn cta-link-large"
								data-nvnotify-form-path="/content/forms/af/nvidia-forms/products-notify-me/consumer-notify-me"
								href="javascript:void(0);">{{'notify_me' | translate}}</a>
						</div>
						<a *ngIf="productDetail.prdStatus === 'upcoming' || productDetail.prdStatus === 'out_of_stock'"
							class="274 dr-spinner-bg featured-buy-link link-btn brand-green  cta-button stock-grey-out cta-link-large"
							href="javascript:void(0);">
							{{ productDetail.prdStatus | translate }}
						</a>
					</div>
				</div>
				<!-- need to check this condition -->
				<div #drId *ngIf="productDetail.digitialRiverID" class="280 js-product-item" data-analytics="btn-dr-id"
					[attr.data-digital-river-id]="changeDRId(productDetail.digitialRiverID)">
					<div #priceDivList class="price  h--smallest js-product-price clearfix 305"></div>
					<div class="price h--smallest outside-page"> <span
							[innerHtml]="extractDRPriceIntegerDot(priceDivList, drSpinnerCont)"></span><span
							class="decimal" [innerHtml]="extractDRPriceDecimal(priceDivList)"></span> </div>
					<div class="buy cta-preorder mobile-top" (click)="transmitToCart()">
						<!-- Logic for NOTIFY ME -->
						<!-- DR NOTIFY ME -->
						<a *ngIf="productDetail.prdStatus === 'dr_notify_me'"
							class="featured-buy-link link-btn brand-green  cta-button show-dr-notify-me cta-link-large 236  "
							href="javascript:void(0);">
							{{ 'add_to_cart' | translate }}
						</a>
						<!-- END OF DR NOTIFY ME -->
						<!-- NV NOTIFY ME -->
						<a *ngIf="productDetail.prdStatus === 'nv_notify_me'"
							class="featured-buy-link link-btn brand-green  cta-button show-nv-notify-me cta-link-large"
							data-nvnotify-form-path="/content/forms/af/nvidia-forms/products-notify-me/consumer-notify-me"
							href="javascript:void(0);">
							{{ 'add_to_cart' | translate }}
						</a>
						<!-- END OF NV NOTIFY ME -->
						<a *ngIf="productDetail.prdStatus === 'buy_now'"
							class="featured-buy-link link-btn brand-green  cta-button cta-link-large"
							href="javascript:void(0);">
							{{ 'add_to_cart' | translate }}
						</a>
						<!-- OUT OF STOCK -->
						<a *ngIf="productDetail.prdStatus === 'out_of_stock'"
							class="featured-buy-link link-btn brand-green  cta-button show-out-of-stock cta-link-large"
							href="javascript:void(0);">
							{{ 'out_of_stock' | translate }}
						</a>
						<!-- END OF OUT OF STOCK -->
						<!-- <div class="product__message limit-per-customer">{{'limit_5' | translate}}</div> -->
						<div *ngIf="productDetail.retailers?.length > 0" class="buy fpc-66"
							[class.fe-pids]="productDetail.manufacturer==='NVIDIA'">
							<div [attr.class]="getEANCode(productDetail.productUPCOriginal)"
								[attr.id]="productDetail.productID" style="display:none">{{productDetail.retailers |
								json}}</div>
							<div>
								<button class="extra_style buy-link cta-link-larges 329 buy-frm-partner"
									[attr.data-pid-code]="productDetail.productID"
									[attr.data-mpn-code]="getEANCode(productDetail.productUPCOriginal)"
									data-color="#76b900" data-secondary-color="#fff"
									(click)="productName(productDetail);">
									{{'buy_from_partners' | translate}}
								</button>
							</div>
						</div>
					</div>
					<div class="ship-date 329"></div>
				</div>
				<div *ngIf="productDetail.digitialRiverID">
					<dr-loading-indicator [show]="drLoading"></dr-loading-indicator>
				</div>
				<div class="compare-remove-container">
					<button class="cta-link-regular 310" [attr.id]="('compare_'+productDetail.productUPC)"
						[class.compare]="productDetail.addRemoveCompare === 'Compare'"
						[class.remove]="productDetail.addRemoveCompare === 'Remove'"
						(click)="compareProduct(productDetail)">{{productDetail.addRemoveCompare | lowercase |
						translate}}</button>

				</div>
			</div>
		</div>
	</div>
</div>